import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography from "@insite/mobius/Typography/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { FC } from "react";
import { css } from "styled-components";

const enum fields {
    videoUrl = "videoUrl",
    content = "content",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.videoUrl]: string;
        [fields.content]: string;
    };
}

export interface CenAboutUsVideoStyles {
    wrapper?: InjectableCss;
    contentContainerStyles?: GridItemProps;
    videoStyles?: GridItemProps;
}

export const cenAboutUsVideoStyles: CenAboutUsVideoStyles = {
    wrapper: {
        css: css`
            margin-top: 56px;
        `,
    },
    contentContainerStyles: {
        width: [12, 12, 12, 6, 6],
    },
    videoStyles: {
        width: [12, 12, 12, 6, 6],
        css: css`
            iframe {
                width: 100%;
                height: 100%;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            aspect-ratio: 1/1;
                        `,
                        css`
                            aspect-ratio: 1/1;
                        `,
                        css`
                            aspect-ratio: 1/1;
                        `,
                        null,
                        null,
                    ])}
            }

            /* position: relative;
            overflow: hidden;
            padding-top: 56.25%;
            iframe {
                position: absolute;
                top: 15px;
                left: 15px;
                max-height: 500px;
                width: 100%;
                height: 100%;
            } */
        `,
    },
};

const styles = cenAboutUsVideoStyles;

export const CENAboutUsVideoWidget: FC<OwnProps> = ({ fields }) => {
    return (
        <GridContainer {...styles.wrapper}>
            <GridItem {...styles.videoStyles}>
                <iframe src={fields.videoUrl} frameBorder="0"></iframe>
            </GridItem>
            <GridItem {...styles.contentContainerStyles}>
                <Typography as="p">{parse(transformContentHtml(fields.content), parserOptions)}</Typography>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: CENAboutUsVideoWidget,
    definition: {
        group: "Basic",
        displayName: "CEN AboutUs Video Widget",
        fieldDefinitions: [
            {
                name: fields.videoUrl,
                fieldType: "General",
                displayName: "Video Url",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                name: fields.content,
                fieldType: "General",
                editorTemplate: "RichTextField",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
